@if (options) {
  <form [formGroup]="form">
    <ul class="options" *limitUp="DEVICE_SIZE.DESKTOP">
      <li *ngFor="let option of options" [ngClass]="{ 'is-selected': currentOption.code === option.code }">
        <label for="option-{{ option.code }}">
          <input
            id="option-{{ option.code }}"
            role="radio"
            type="radio"
            aria-checked="true"
            [value]="option.code"
            formControlName="option"
            (click)="handlerClickRadio(option)"
          />
          <span class="title">
            {{ option.label }}

            @if (option.icon) {
              <div class="icon">
                <tooltip-icon [icon]="option.icon.content" [content]="option.icon.message"></tooltip-icon>
              </div>
            }
          </span>
        </label>
      </li>
    </ul>

    <div class="form-group group-form-select" *smallerThan="DEVICE_SIZE.DESKTOP">
      <label for="">
        <select class="form-control" formControlName="option">
          <option *ngFor="let option of options" [attr.aria-label]="option.label" value="{{ option.code }}">
            {{ option.label }}
          </option>
        </select>

        @if (currentOption.icon) {
          <div class="icon">
            <tooltip-icon [icon]="currentOption.icon.content" [content]="currentOption.icon.message"></tooltip-icon>
          </div>
        }
      </label>
    </div>
  </form>
}
